module.exports = __webpack_public_path__ + "static/media/point.3e4aa4ee.svg";